import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const PostTypeModal = () => {
  const [selectedPostType, setSelectedPostType] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(true); // Modal visibility state
  const navigate = useNavigate();

  const handlePostTypeChange = (e) => {
    setSelectedPostType(e.target.value);
  };

  const handleSubmit = () => {
    if (selectedPostType) {
      // Navigate to the specific page based on the selected post type
      switch (selectedPostType) {
        case "Transportation":
          navigate("/Managed Care Organization's/Transportation");
          break;
        case "Service Information":
          navigate("/Managed Care Organization's/Service Information");
          break;
        default:
          break;
      }
      setIsModalOpen(false); // Close modal after submission
    }
  };

  const handleClose = () => {
    setIsModalOpen(false); // Close modal
  };

  if (!isModalOpen) return null; // Do not render modal if it is closed

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      onClick={handleClose} // Close modal on backdrop click
    >
      <div
        className="bg-white rounded-lg p-6 w-96"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Post Type</h2>
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 text-3xl"
          >
            &times;
          </button>
        </div>

        <div className="mb-6">
          <label className="block text-gray-700 mb-2" htmlFor="postType">
            Select Post Type
          </label>
          <select
            id="postType"
            value={selectedPostType}
            onChange={handlePostTypeChange}
            className="block w-full border border-gray-300 rounded-md p-2 text-gray-700"
          >
            <option value="">Select</option>
            <option value="Transportation">Transportation</option>
            <option value="Service Information">Service Information</option>
          </select>
        </div>

        <div className="flex justify-between items-center mt-6">
          <button
            onClick={handleSubmit}
            className="bg-purple-700 text-white w-full py-2 rounded-lg hover:bg-purple-800"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostTypeModal;
